// extracted by mini-css-extract-plugin
export default {"category":"lOWTmo","categoryName":"b_WzcN","items":"OZ2rCh"};